export default __webpack_public_path__ + "static/media/short.e0927b10.mp3";